module.exports = __webpack_public_path__ + "static/img/杨俊杰照片.63fef59d.png";